import Parallax from "parallax-js/dist/parallax";


function initParallax() {
	[... document.querySelectorAll('[data-vg-toggle="parallax"]')].forEach(el => {
		new Parallax(el);
	})
}

export default initParallax;
